import { FaqListing as HygraphFaqListing } from '@/lib/types';
import { useGlobalContext } from '@/hooks/use-global-context';

import { CardProps } from '@/components/card';
import Card from '@/components/card';
import { HygraphImageProps } from '@/components/hygraph-image';
import { LinkVariant } from '@/components/link';
import Row from '@/components/row';
import Typography from '@/components/typography';

import { CardStyle } from '@/enums/card-style';
import { HorizontalAlignment } from '@/enums/horizontal-alignment';
import { ImageWidth } from '@/enums/image-width';
import { RowLayout } from '@/enums/row-layout';
import { VerticalSide } from '@/enums/vertical-side';
import useFaqPageContext from '@/features/faq-page/hooks/use-faq-page-context';

export default function FaqListingRenderer(props: HygraphFaqListing) {
  const { faqPageStaticData } = useFaqPageContext();
  const { pageStaticData } = useGlobalContext();
  const loadedProps =
    faqPageStaticData?.faqPageListings?.[props.id] ||
    pageStaticData?.faqPageListings?.[props.id] ||
    null;

  const defaultCardImage: HygraphImageProps = {
    url: 'https://media.graphassets.com/pDTbWNlgRvGs6xvsNGcb',
    height: 230,
    width: 330,
  };

  return (
    <div>
      {props.heading && (
        <Typography.Heading1 className='mb-8'>
          {props.heading}
        </Typography.Heading1>
      )}

      {loadedProps && loadedProps.length && (
        <Row
          layout={RowLayout.THREE_COLUMN}
          className='mb-5 mt-2 justify-center sm:gap-y-8 sm:px-0 lg:justify-start lg:px-0'
        >
          {loadedProps.map((faqCard, index) => {
            const cardImage = faqCard.cardImage
              ? faqCardImageTransformer(faqCard.cardImage)
              : defaultCardImage;

            cardImage.description = faqCard.title;
            cardImage.imgClassName = 'w-full';

            const cardProps: CardProps = {
              image: cardImage,
              imagePosition: VerticalSide.TOP,
              imageWidth: ImageWidth.FULL_WIDTH,
              title: faqCard.title,
              cardStyle: CardStyle.WHITE_WITH_BORDER,
              textAlignment: HorizontalAlignment.LEFT,
              link: {
                href: faqCard.fullUrl,
                children: 'Read More',
                variant: LinkVariant.LINK_WITH_PLUS,
              },
            };
            return <Card key={index} {...cardProps} />;
          }) || <></>}
        </Row>
      )}
    </div>
  );
}

const faqCardImageTransformer = (
  image: HygraphImageProps
): HygraphImageProps => {
  return {
    ...image,
    height: 230,
    width: 330,
  };
};
